import OfficeFilePreview from './OfficeFilePreview.component';

export default OfficeFilePreview;